import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTranslation } from './utils/util';
import { 
    UploadImageContainer,
    AttachedImagesContainer,
    AttachedImagesContainer2,
    AttachedImagesContainer3,
    FileNameDiv,
    UploadContainer2
} from '../index.styled';
import AttachIcon from 'src/assets/images/attach_icon.svg';
import DeleteIcon from 'src/assets/images/DeleteIcon.svg';
import { FONT_FAMILY_DEMI, SMALL_TEXT_PX, TITLE_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';

const iconStyle = {
    width: '12px',
    height: '12px', 
    flex: '0 0 auto',
    marginRight: '4px'
};

const deleteIconStyle = {
    cursor: 'pointer', 
    alignSelf: 'flex-end',
    flex: '0 0 auto',
};

const UploadImage = ({ 
    attachedFiles, 
    onDeleteFile, 
    onViewFile,
    showAttachLoader,
    japaneseTranslations,
    isLanguageChanged
}) => {
    const { t } = useTranslation();

    return (
        <>
            {/* Display attached files */}
            {attachedFiles.length > 0 && (
                <AttachedImagesContainer> 
                    <AttachedImagesContainer2>
                        {attachedFiles.map((file, index) => (
                            <AttachedImagesContainer3
                                key={index}
                                isLast={index === attachedFiles.length - 1}
                            >
                                <img 
                                    src={AttachIcon} 
                                    alt="attach" 
                                    style={iconStyle}
                                />
                                <FileNameDiv className="uploaded-po-filename-dt-mask"
                                    onClick={() => onViewFile(file)}
                                >
                                    {file.name}
                                </FileNameDiv>
                                <img 
                                    src={DeleteIcon} 
                                    alt="delete" 
                                    id = 'uploaded-image-delete'
                                    onClick={() => onDeleteFile(index)}
                                    style={deleteIconStyle}
                                />
                            </AttachedImagesContainer3>
                        ))}
                    </AttachedImagesContainer2>
                </AttachedImagesContainer>
            )}
            
            {/* Upload button */}
            <UploadImageContainer
                id={'upload-image-container'}
                removeMargin={attachedFiles?.length > 0 ? true : ''}
            >
                <UploadContainer2>
                    <label 
                        htmlFor="file-upload"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            textAlign: 'start', 
                            fontSize: SMALL_TEXT_PX,
                            fontFamily: FONT_FAMILY_DEMI || 'sans-serif',
                            color: TITLE_FONT_COLOR
                        }}
                    >
                        {showAttachLoader ? (
                            <div style={{ 
                                width: '12px', 
                                height: '12px',
                                marginRight: '6px',
                                border: '2px solid #1010eb',
                                borderTop: '2px solid transparent',
                                borderRadius: '50%',
                                animation: 'spin 0.6s linear infinite'
                            }} />
                        ) : (
                            <img 
                                src={AttachIcon} 
                                alt="attach" 
                                style={{ 
                                    width: '12px', 
                                    height: '12px',
                                    marginRight: '6px'
                                }} 
                            />
                        )}
                        {getTranslation(t, 'reportIssue.attachImage', isLanguageChanged, japaneseTranslations, 'Attach File')}
                    </label>
                </UploadContainer2>
            </UploadImageContainer>
        </>
    );
};

export default UploadImage;
